var e = {
	searchInput: { search: "Search" },
	mapSearch: { placeholder: "Search places..." },
	formLayout: {
		unsavedChanges: "You have unsaved changes. Are you sure you want to exit?",
		goBack: "Go back",
		back: "Back",
		next: "Next"
	},
	select: {
		noResults: "No results found",
		placeholder: "Select an option",
		multiplePlaceholder: "Select Options",
		multipleEmpty: "Select options",
		selectedDefault: "Selected",
		selectedWithCount: "{{label}} ({{count}})",
		searchPlaceholder: "Search…",
		loading: "Loading…",
		selectedCount_one: "{{count}} selected",
		selectedCount_other: "{{count}} selected"
	},
	numberInput: {
		decrement: "Decrease",
		increment: "Increase"
	},
	numberField: { units: {
		minutes: "min",
		days: "days",
		kilometres: "km",
		years: "years"
	} },
	rating: { starLabel: "Rate {{value}} out of {{max}}" },
	timePicker: {
		selectTime: "Select time",
		dialogLabel: "Time picker",
		done: "Done",
		hour: "Hour",
		minute: "Min",
		meridiem: "AM/PM"
	},
	scheduleEditor: {
		removeTime: "Remove",
		horizonUnit: "days",
		nextDay: "+1",
		duplicateTime: "That time is already on the schedule.",
		overlappingHours: "Those hours overlap a window you already added.",
		addStartTime: "Add a start time",
		until: "Until"
	},
	grid: { empty: "No items found." },
	carousel: {
		previous: "Previous",
		next: "Next",
		pageIndicator: "{{page}} / {{count}}"
	},
	copyButton: {
		copy: "Copy",
		copied: "Copied"
	},
	codeBlock: {
		showAll: "Show all",
		showLess: "Show less"
	},
	masterDetail: { close: "Close" },
	quickActions: { title: "Quick Actions" },
	floatingPanel: { close: "Close panel" },
	aiLoading: { default: "Generating context..." },
	imageCropper: {
		title: "Crop image",
		zoom: "Zoom",
		caption: "Drag to reposition; scroll or use the slider to zoom. The image is framed to the highlighted area."
	},
	roleSelector: {
		guest: {
			title: "Guest",
			description: "I want to rent properties and explore unique locations around the world."
		},
		host: {
			title: "Host",
			description: "I want to manage properties, host guests, and grow my rental business."
		}
	},
	table: {
		empty: "No data available",
		filters: "Filters",
		selectedCount_one: "{{count}} item selected",
		selectedCount_other: "{{count}} items selected"
	},
	gallery: {
		prevImage: "Previous image",
		nextImage: "Next image",
		close: "Close gallery",
		imageAlt: "Image",
		title: "Image viewer",
		counter: "{{index}} of {{total}}"
	},
	calendar: {
		filters: "Filters",
		myCalendars: "My Calendars",
		status: "Status",
		blocks: "Blocks",
		hostBlock: "Host block",
		otaIcal: "OTA / iCal",
		blocked: "Blocked",
		today: "Today",
		previous: "Previous",
		next: "Next",
		unit: "Unit",
		roomCount_one: "{{count}} room",
		roomCount_other: "{{count}} rooms",
		nights_one: "{{count}} night",
		nights_other: "{{count}} nights",
		reservations_one: "{{count}} Reservation",
		reservations_other: "{{count}} Reservations",
		viewMode: {
			day: "Day",
			week: "Week",
			month: "Month"
		},
		empty: {
			day: "No reservations for this day",
			month: "No reservations this month",
			default: "No reservations"
		}
	},
	datePicker: {
		selectDate: "Select date",
		selectDateRange: "Select date range",
		dialogLabel: "Date picker",
		rangeDialogLabel: "Date range picker",
		clearDates: "Clear dates",
		prevMonth: "Previous month",
		nextMonth: "Next month",
		prevYear: "Previous year",
		nextYear: "Next year",
		pickMonthYear: "Pick month and year",
		checkInDay: "Check-in day",
		checkOutDay: "Check-out day",
		nightNumber: "Night {{count}}",
		availableCheckout: "Available for check-out",
		reason: {
			unavailableCheckIn: "Not available for check-in",
			unavailable: "Not available",
			minNights_one: "{{count}}-night minimum stay",
			minNights_other: "{{count}}-night minimum stay",
			maxNights_one: "{{count}}-night maximum stay",
			maxNights_other: "{{count}}-night maximum stay",
			checkoutUnavailable: "Checkout not available on this day",
			spanUnavailable: "Your stay can’t span unavailable dates"
		}
	},
	footer: { copyright: "© 2026 Maat, Inc." },
	emptyState: {
		conversations: {
			title: "No messages yet",
			body: "Guest conversations will appear here."
		},
		bookingRequests: {
			title: "No booking requests",
			body: "New requests from guests land here for your review."
		},
		reviews: {
			title: "No reviews yet",
			body: "Guest reviews appear once a stay is complete."
		},
		earnings: {
			title: "Nothing earned yet",
			body: "Payouts and revenue show here after your first completed booking."
		},
		calendar: {
			title: "Nothing scheduled",
			body: "Check-ins, check-outs and blocked dates appear on this calendar."
		},
		listings: {
			title: "No properties listed",
			body: "Add your first property to start taking bookings.",
			action: "Add property"
		},
		rules: {
			title: "No rules set",
			body: "Pricing and booking rules you create will be listed here.",
			action: "Create rule"
		},
		team: {
			title: "You're the only member",
			body: "Invite teammates to help manage your properties.",
			action: "Invite member"
		},
		coupons: {
			title: "No coupons yet",
			body: "Create a coupon to offer guests a discount.",
			action: "Create coupon"
		},
		notifications: {
			title: "You're all caught up",
			body: "Notifications about bookings and messages appear here."
		},
		occupancy: {
			title: "No occupancy data yet",
			body: "Occupancy shows once your properties have booked nights."
		},
		coffeeBreak: {
			title: "No action required",
			body: "You're all caught up. Enjoy the coffee break."
		},
		activity: {
			title: "No upcoming activity",
			body: "Arrivals and departures for this property show here once bookings are confirmed."
		},
		payouts: {
			title: "No upcoming payouts",
			body: "Scheduled payouts appear here once a stay is confirmed."
		},
		withdrawals: {
			title: "No withdrawals yet",
			body: "Transfers to your bank account will be listed here."
		},
		documents: {
			title: "No documents shared",
			body: "ID documents shared for this booking will appear here."
		},
		noMatch: {
			title: "No matches",
			body: "Nothing fits these filters. Try widening your search."
		}
	},
	emptyPage: {
		thread: {
			title: "Start the conversation",
			body: "Ask about check-in time, parking, or anything else you need before your stay."
		},
		conversations: {
			title: "No conversations yet",
			body: "Messages between you and your hosts and guests will appear here."
		},
		notifications: {
			title: "Nothing new",
			body: "Updates about bookings, messages and payouts arrive here."
		},
		upcoming: {
			title: "No upcoming bookings",
			body: "Once a booking is confirmed it shows here with your dates and check-in details."
		},
		past: {
			title: "No past bookings",
			body: "Completed stays move here, with their receipt and the option to leave a review."
		},
		properties: {
			title: "No properties yet",
			body: "Add your first property to start taking bookings.",
			action: "Add property"
		},
		propertyGroups: {
			title: "No property groups",
			body: "Group properties to manage rules and pricing across several at once.",
			action: "Create group"
		},
		bookingRules: {
			title: "No booking rules",
			body: "Rules you create control minimum stays, notice periods and which days guests can check in.",
			action: "Create rule"
		},
		pricingRules: {
			title: "No pricing rules",
			body: "Add seasonal rates, weekend pricing and long-stay discounts on top of your base price.",
			action: "Create rule"
		},
		travelGuides: {
			title: "No travel guides yet",
			body: "Share local recommendations with guests: where to eat, what to do, how to get around.",
			action: "Write a guide"
		},
		withdrawalsRequested: {
			title: "No withdrawals requested",
			body: "Request a withdrawal from your balance and it will show here while it is pending.",
			action: "Request withdrawal"
		},
		cancellationPenalties: {
			title: "No cancellation penalties",
			body: "Penalties charged for cancelled stays would be listed here, with the booking they came from."
		},
		penaltiesSettlement: {
			title: "Nothing to settle",
			body: "When a penalty is charged, the amount owed and how it is settled appear here."
		},
		withdrawalMethods: {
			title: "No withdrawal methods",
			body: "Add a bank account or card so your payouts have somewhere to go.",
			action: "Add method"
		},
		couponsCreated: {
			title: "No coupons created",
			body: "Create a coupon to offer guests a discount on selected dates or properties.",
			action: "Create coupon"
		}
	},
	verifiedIdentityBadge: {
		verified: "Verified",
		verifiedOn: "Verified {{date}}",
		notVerified: "Not verified"
	},
	phoneInput: {
		codePlaceholder: "Code",
		codeSearchPlaceholder: "Search countries",
		numberPlaceholder: "Phone number"
	}
};
//#endregion
export { e as default };
